export default __webpack_public_path__ + "static/media/ITER_TCC1.f0808577.44b6a671.pdf";